import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
//import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import Swal from 'sweetalert2';
import Loader from "../../../../../customComponents/CustomLoader";

const BusinessPartnerTypeInputs = [
  {
    name: "business_partner_type_name",
    label: "Department Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true,
      pattern: /^[A-Za-z0-9-\s]*$/,
      message: "Special symbols are not allowed",
     },
  },
  {
    name: "business_partner_type_desc",
    label: "Description",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
    validation: { required: true },
  },
  {
    name: "status",
    label: "Status",
    type: "dropdown",
    required: true,
    options: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" },
    ],
    validation: {
      required: true,
      message: "Status is required",
    },
    gridClass: "col-lg-4",
  }
  // {
  //   name: "actions",
  //   label: "Actions",
  //   type: "multiselectdropdown",
  //   required: true,
  //   options: [
  //     { label: "Edit", value: "Edit" },
  //     { label: "Delete", value: "Delete" },
  //   ],
  //   gridClass: "col-lg-4",
  // },
];
const EditBusinessPartnerType = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [ businessPartnerType, setBusinessPArtnerType ] = useState([])
  const Token = localStorage.getItem("authToken");

  const location = useLocation();
  const { data } = location.state || {};

  const fetchBusinessPartnerTypeEdit = async () => {
    try{
      const response = await axiosInstance.get(`/businesspartnertype/edit/${data.business_partner_type_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
        },
    })
    const fetchedData = response.data.data
    const formatedData = {
      business_partner_type_name: fetchedData.business_partner_type_name,
        business_partner_type_desc: fetchedData.business_partner_type_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
    }
    setFormData(formatedData)
    setBusinessPArtnerType(fetchedData)
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }
  
  useEffect(() => {
    fetchBusinessPartnerTypeEdit()
  },[])

const handleFormSubmit = async (formData) => {
  const errors = {};
  let isValid = true;
  BusinessPartnerTypeInputs.forEach((field) => {
    if (field.validation && field.validation.required) {
      if (!formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
    }
  });
  if (!isValid) {
    setValidationErrors(errors);
    return;
  }
  Swal.fire({
    title: "Are you sure?",
    text: "Do you want to update this Business Partner Type?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
     
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        setLoading(true)
        const payload = {
          business_partner_type_name: formData.business_partner_type_name,
          business_partner_type_desc: formData.business_partner_type_desc,
          status: formData.status === "Active" ? 1 : 0,
        };
        const response = await axiosInstance.patch(`/businesspartnertype/update/${data.business_partner_type_id}`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        Swal.fire({
          title: "Success",
          text: "Business Partner Type updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate('/admin/manage-dealer/business-partner-type');
        });

      } catch (error) {
        console.error('Error updating business partner type:', error);
        const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
        Swal.fire({
          title: "Error",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // Handle cancel action
      Swal.fire({
        title: "Cancelled",
        text: "Your changes were not saved.",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  });
};


  return (
    <>
      {loading ? (
          <Loader />
        ) : (
          <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Business Partner Type</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter Business Partner Type Details
        </span>
        <DynamicForm
          formConfig={BusinessPartnerTypeInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
        )}
    </>
  );
};

export default EditBusinessPartnerType;
